export enum AnalystChartXAxisKind {
  Category = 0,
  DateTime = 1,
  Date = 2,
}
